import JwtSignUpForm from '@auth/services/jwt/components/JwtSignUpForm';

function JwtSignUpTab({config, social}) {
	return <JwtSignUpForm config={config} social={social} />;
}

export default JwtSignUpTab;
